import { action } from 'typesafe-actions';

import { IRequirementsTemplate } from 'APIPackage/AccountModule/interfaces/IRequirementsTemplate';

import { UserRequirementsActionsEnum } from '../enums/UserRequirementsActionsEnum';
import { IRequirementsForm } from '../interfaces/IRequirementsForm';

export const userRequirementsInitPage = () => action(UserRequirementsActionsEnum.USER_REQUIREMENTS_INIT_PAGE);
export const userRequirementsResetPage = () => action(UserRequirementsActionsEnum.USER_REQUIREMENTS_RESET_PAGE);
export const userRequirementsGetTemplateList = () =>
  action(UserRequirementsActionsEnum.USER_REQUIREMENTS_GET_TEMPLATE_LIST);
export const userRequirementsGetTemplateListNextPage = () =>
  action(UserRequirementsActionsEnum.USER_REQUIREMENTS_GET_TEMPLATE_LIST_NEXT_PAGE);
export const userRequirementsSetTemplateList = (
  templatesList: IRequirementsTemplate[],
  page: number,
  pageCount: number,
  totalCount: number,
) =>
  action(UserRequirementsActionsEnum.USER_REQUIREMENTS_SET_TEMPLATE_LIST, {
    templatesList,
    page,
    pageCount,
    totalCount,
  });
export const userRequirementsSetActiveTemplateId = (id: number | 'new') =>
  action(UserRequirementsActionsEnum.USER_REQUIREMENTS_SET_ACTIVE_TEMPLATE_ID, { id });
export const userRequirementsUpdate = (values: IRequirementsForm) =>
  action(UserRequirementsActionsEnum.USER_REQUIREMENTS_UPDATE, { values });
export const userRequirementsDelete = (id: number) =>
  action(UserRequirementsActionsEnum.USER_REQUIREMENTS_DELETE, { id });
export const userRequirementsChangeDefault = (id?: number) =>
  action(UserRequirementsActionsEnum.USER_REQUIREMENTS_CHANGE_DEFAULT, { id });
export const userRequirementsFormSubmit = (
  values: IRequirementsForm,
  initialValues: IRequirementsForm,
  resetForm: (() => void) | undefined,
) => action(UserRequirementsActionsEnum.USER_REQUIREMENTS_FORM_SUBMIT, { values, initialValues, resetForm });
